import {
  GET_COMPANY_NOTICE,
  SHOW_COMPANY_NOTICE,
  CREATE_COMPANY_NOTICE,
  EDIT_COMPANY_NOTICE,
  DELETE_COMPANY_NOTICE
} from "@/store/modules/mutation-types";

export default {
  state: {},
  getters: {},
  actions: {
    async [GET_COMPANY_NOTICE]({ dispatch }, params) {
      const res = await dispatch("apiGet", {
        url: "/kanri/company_notices",
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [SHOW_COMPANY_NOTICE]({ dispatch }, params) {
      let url = "/kanri/company_notices/" + params.id;
      const res = await dispatch("apiGet", {
        url: url,
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [CREATE_COMPANY_NOTICE]({ dispatch }, params) {
      const res = await dispatch("apiPost", {
        url: "/kanri/company_notices",
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [EDIT_COMPANY_NOTICE]({ dispatch }, params) {
      let url = "/kanri/company_notices/" + params.id;
      const res = await dispatch("apiPatch", {
        url: url,
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [DELETE_COMPANY_NOTICE]({ dispatch }, params) {
      let url = "/kanri/company_notices/" + params.id;
      const res = await dispatch("apiDelete", {
        url: url,
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    }
  },
  mutations: {}
};
